import { render } from "./Events.vue?vue&type=template&id=499291fd&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"

import "./Events.vue?vue&type=style&index=0&id=499291fd&scoped=true&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499291fd"]])

export default __exports__